import React, { FC, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Form.module.scss';
import { Alert } from 'esa-ui-library';
import { PageContext, ANIMATE_HEIGHT } from '../..';
import { debounce, useStore } from '../../../common';

interface FormProps {
	children: JSX.Element | JSX.Element[];
	errors?: string[];
	success?: string;
}

const Form: FC<FormProps> = ({ children, errors = [], success = '' }): JSX.Element => {
	const [, dispatch] = useStore(false);
	const page = useContext(PageContext);

	useEffect(() => {
		if (errors.length || success) {
			page.scroll();
			debounce(() => dispatch('MESSAGE_INVALIDATE'), 3000);
		}
	}, [errors, success]);

	return (
		<section className={styles.Form}>
			{(errors.length || success) && (
				<Alert
					text={errors.join('\r\n') || success}
					danger={!!errors.length}
					className={`${styles.Alert} ${ANIMATE_HEIGHT}`}
					dataId='alert-message'
				/>
			)}
			{children}
		</section>
	);
};

Form.propTypes = {
	success: PropTypes.string,
};

export { Form };
